import { render, staticRenderFns } from "./project-orders.vue?vue&type=template&id=bf39686c&scoped=true"
import script from "./project-orders.vue?vue&type=script&lang=js"
export * from "./project-orders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf39686c",
  null
  
)

export default component.exports